import { FC, lazy } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { useCapacityManagementRoot } from 'src/apis/capacity-management/use-capacity-management-root';
import { useDeal } from 'src/apis/capacity-management/use-deal';
import { ThrowNotFound } from 'src/components/feedback/not-found';
import { PageSpinner } from 'src/components/spinner-container';
import { useReferrer } from 'src/hooks/use-referrer2';

const Page = lazy(() => import('./page'));

export const CreateConversion: FC = () => {
  const capacityManagementRoot = useCapacityManagementRoot();
  const deal = useDeal({ capacityManagementRoot });
  const referrer = useReferrer({
    label: 'My Transactions',
    location: '/reporting/my-transactions',
  });

  // avoid pop in of page titles in case of 401s
  if (!capacityManagementRoot.response) return <PageSpinner />;

  return (
    <Switch>
      <Route path="/reporting/my-transactions/deals/:dealId/conversions/create/:direction(exit|entry)">
        <Page deal={deal} />
      </Route>

      <Route
        path="/reporting/my-transactions/deals/:dealId/conversions/create"
        exact
      >
        {!deal.response ? (
          <PageSpinner />
        ) : deal.response.data.exit?._links.createConversionRequest ? (
          <Redirect
            to={referrer.attachTo(
              `/reporting/my-transactions/deals/${deal.response.data.dealId}/conversions/create/exit`
            )}
          />
        ) : (
          <Redirect
            to={referrer.attachTo({
              pathname: `/reporting/my-transactions/deals/${deal.response.data.dealId}/conversions/create/entry`,
            })}
          />
        )}
      </Route>

      <ThrowNotFound />
    </Switch>
  );
};
